(function () {
  'use strict';

  class CiariEngineering extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.stage = this.querySelector('.ceg__stage');
      this.slides = Array.from(this.querySelectorAll('.ceg__slide'));
      this.items = Array.from(this.querySelectorAll('.ceg__item'));
      this.index = 0;
      this.delay = parseInt(this.dataset.autoplayDelay, 10) || 2500;
      this.autoplay = this.dataset.autoplay === 'true' && !this.reducedMotion;

      if (!this.stage || this.slides.length < 2) {
        this.dataset.static = '';
        this.sync();
        return;
      }

      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.addEventListener('click', (event) => this.onClick(event), { signal });
      this.addEventListener('pointerover', (event) => this.onPointerOver(event), { signal });
      this.addEventListener('pointerleave', () => this.onPointerLeave(), { signal });
      this.addEventListener('focusin', (event) => this.onFocusIn(event), { signal });
      this.addEventListener('focusout', () => this.onFocusOut(), { signal });
      document.addEventListener('visibilitychange', () => this.onVisibilityChange(), { signal });
      this.cleanupDrag = window.CiariCarousel.initializeHorizontalDragScroll(this.stage, {
        allowTouch: true,
        moveScroll: false,
        onDragEnd: (drag) => {
          const distance = drag.endX - drag.startX;
          if (Math.abs(distance) >= 40) this.show(this.index + (distance < 0 ? 1 : -1));
        }
      });
      this.sync();
      this.schedule();
    }

    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.sync();
      this.schedule();
    }

    sync() {
      this.slides.forEach((slide, index) => {
        const active = index === this.index;
        slide.toggleAttribute('data-active', active);
        if (active) slide.removeAttribute('aria-hidden');
        else slide.setAttribute('aria-hidden', 'true');
      });
      this.items.forEach((item, index) => {
        const active = index === this.index;
        item.toggleAttribute('data-active', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    schedule() {
      window.clearTimeout(this.timer);
      if (!this.autoplay || this.pointerPaused || this.keyboardPaused || document.hidden) return;
      this.timer = window.setTimeout(() => this.show(this.index + 1), this.delay);
    }

    onClick(event) {
      const item = event.target.closest('.ceg__item');
      if (!item || !this.contains(item)) return;
      const index = parseInt(item.dataset.index, 10);
      if (!Number.isNaN(index)) this.show(index);
    }

    onPointerOver(event) {
      if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
      const item = event.target.closest('.ceg__item');
      if (!item || item.contains(event.relatedTarget)) return;
      const index = parseInt(item.dataset.index, 10);
      this.pointerPaused = true;
      if (!Number.isNaN(index)) this.show(index);
      this.schedule();
    }

    onPointerLeave() {
      this.pointerPaused = false;
      this.schedule();
    }

    onFocusIn(event) {
      const item = event.target.closest('.ceg__item');
      if (item) {
        const index = parseInt(item.dataset.index, 10);
        if (!Number.isNaN(index)) this.show(index);
      }
      try {
        if (!event.target.matches(':focus-visible')) return;
      } catch (error) {
        return;
      }
      this.keyboardPaused = true;
      this.schedule();
    }

    onFocusOut() {
      this.keyboardPaused = false;
      this.schedule();
    }

    onVisibilityChange() {
      this.schedule();
    }

    get reducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    disconnectedCallback() {
      this.initialized = false;
      window.clearTimeout(this.timer);
      if (this.controller) this.controller.abort();
      if (this.cleanupDrag) this.cleanupDrag();
    }
  }

  if (!customElements.get('ciari-engineering')) customElements.define('ciari-engineering', CiariEngineering);
})();
